export const convertExceptionPersonToArray = (exceptionPerson) => {
    let areaArray = [];
    if (exceptionPerson.isAllCustomer == "TRUE") {
        areaArray.push(-1);
        return areaArray;
    }

    areaArray = [ ...exceptionPerson.includeCustomerAreaBlock, ...exceptionPerson.includeCustomerTown , ...exceptionPerson.includeCustomerId];

    return areaArray;
}